import { imageUrl } from '../../../utils';

export const partnershipsMap = {
  deltaSkymiles: {
    imageUrl: `${imageUrl}/rewards/loyalty-partnerships/delta-skymiles.png`,
    imageAlt: 'Delta Skymiles',
    description: 'deltaSkymilesDescription',
    learnMoreUrl:
      'https://www.deltastarbucks.com/content/starbucks/en/overview.html?mkcpgn=dipd-sbux7042',
    disclaimerTarget: {
      number: '1',
      id: 'deltaNoteId',
      descriptionId: 'deltaSkymilesTermsDescriptionId',
    },
  },
  aeroplan: {
    imageUrl: `${imageUrl}/rewards/loyalty-partnerships/aeroplan.png`,
    imageAlt: 'Aeroplan',
    description: 'aeroplanDescription',
    learnMoreUrl:
      'https://www.aircanada.com/ca/en/aco/home/aeroplan/partners/starbucks.html#/',
    disclaimerTarget: {
      number: '1',
      id: 'aeroplanNoteId',
      descriptionId: 'aeroplanTermsDescriptionId',
    },
  },
  bankOfAmerica: {
    imageUrl: `${imageUrl}/rewards/loyalty-partnerships/bank-of-america.png`,
    imageAlt: 'Bank of America',
    description: 'bankOfAmericaDescription',
    learnMoreUrl:
      'https://promotions.bankofamerica.com/starbucks?cm_mmc=ESZ-EnterpriseSales-_-Cobrand_Site-_-ES35LT0004_StarbucksRewardsModuleBofA_SRModuleBofA-_-StarbucksPartnerMktg',
    disclaimerTarget: {
      number: '2',
      id: 'bankOfAmericaNoteId',
      descriptionId: 'bankOfAmericaTermsDescriptionId',
    },
  },
  tdBank: {
    imageUrl: `${imageUrl}/rewards/loyalty-partnerships/td-bank.png`,
    imageAlt: 'TD Bank',
    description: 'tdBankDescription',
    learnMoreUrl:
      'https://www.td.com/ca/en/personal-banking/products/credit-cards/starbucks?cm_sp=Siren-SBUXLP-EN',
    disclaimerTarget: {
      number: '2',
      id: 'tdBankNoteId',
      descriptionId: 'bankOfAmericaTermsDescriptionId',
    },
  },
  marriott: {
    imageUrl: `${imageUrl}/rewards/loyalty-partnerships/marriott-bonvoy/marriott-logo.png`,
    imageAlt: 'Marriott Bonvoy®',
    description: 'marriottDescription',
    learnMoreUrl:
      'https://www.starbucks.com/rewards/partnerships/marriottbonvoy',
    disclaimerTarget: {
      number: '3',
      id: 'marriottNoteId',
      descriptionId: 'marriottTermsDescriptionId',
    },
  },
};
